import { useEffect, useState } from "react";
import { Badge, Card, Col, Collapse, InputGroup, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const FieldErrorNotification = ({
  Show,
  Hide,
  Title,
  dataEntryQueryNotification,
  tableRef,
  onMouseDown,
  formName,
  version,
  formType,
  queryNotificationDataLoader,
  dataEntryQueryNotificationDiscussionLoader,
  queryNotificationStatusButtonLoader,
  dataEntryQueryNotificationDiscussion,
  getStudySubjectFormFieldQueryNotificationDiscussionDataEntry,
  generateQueryNotificationStatusStudySubjectFormField,
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  const [queryNotificationData, setQueryNotificationData] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [studyTabData, setStudyTabData] = useState("");
  const [fieldTab, setFieldTab] = useState("");

  useEffect(() => {
    if (!fieldTab) return;
    setQueryNotificationData(
      dataEntryQueryNotification?.find(
        item => item.fieldName === fieldTab
      ) || {}
    );
  }, [fieldTab, dataEntryQueryNotification]);

  const checkActiveDynamicTabData = () => {
    const savedStudyTabData = JSON.parse(localStorage.getItem("studyTabs")) || [];
    let tablData = savedStudyTabData?.find(

      (item) => item.studyTabId?.includes("viewEventSchemaFormLists") && item.status === "active"
    );
    setStudyTabData(tablData?.idObject || "");
  };

  useEffect(() => {
    if (Show && dataEntryQueryNotification?.length > 0) {
      setFieldTab(dataEntryQueryNotification?.[0]?.fieldName);
      getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(dataEntryQueryNotification?.[0]?.queryId)
    }
  }, [Show, dataEntryQueryNotification]);

  useEffect(() => {
    if (Show) {
      checkActiveDynamicTabData();
    }
  }, [Show]);

  const getStatusBadge = (status) => {
    const statusMap = {
      "open": "danger",
      "re-open": "danger",
      "answered": "primary",
      "responded": "primary",
      "close": "success",
      "cancel": "warning",
    };
    return statusMap[status] || "secondary";
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {queryNotificationDataLoader ?
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <PageLoader />
            </div>
            : dataEntryQueryNotification?.length === 0 ?
              <div
                className="hstack justify-content-center"
                style={{ height: "calc(100vh - 44px)" }}
              >
                <NoDataFoundTable MSG={"Field query history not found!"} />
              </div>
              : dataEntryQueryNotification?.length > 0 &&
              <div className="p-3">
                {dataEntryQueryNotification?.length > 0 &&
                  <InputGroup className="w-auto mb-2">
                    {dataEntryQueryNotification?.map((item, index) => (
                      <button key={index} onClick={() => { setFieldTab(item?.fieldName); getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(item?.queryId) }} className={`updateProfile ${fieldTab === item?.fieldName ? "activee" : ""}`}>
                        {isHTMLIdentifier(item?.fieldLabel || "") ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.fieldLabel,
                            }}
                          />
                        ) : (
                          item?.fieldLabel
                        )}
                      </button>
                    ))}
                  </InputGroup>
                }
                {fieldTab &&
                  <>
                    <Card className="mb-2 border bg-light">
                      <Card.Body className="p-3">
                        <Row className="mb-2">
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Site</small>
                            <div style={{ fontSize: "13px" }}>{studyTabData.siteName}</div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Subject</small>
                            <div style={{ fontSize: "13px" }}>{studyTabData.subjectName}</div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Event</small>
                            <div style={{ fontSize: "13px" }}>{studyTabData.eventName} {studyTabData?.timePointLabel && `(${studyTabData?.timePointLabel})`}</div>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Form</small>
                            <div style={{ fontSize: "13px" }}>{formName}</div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Version</small>
                            <div style={{ fontSize: "13px" }}>v{version}</div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Form Type</small>
                            <div className="text-capitalize" style={{ fontSize: "13px" }}>{formType}</div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-2 border bg-light">
                      <Card.Body className="p-3">
                        <Row>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Field Label (Name)</small>
                            <div style={{ fontSize: "13px" }}>
                              {isHTMLIdentifier(queryNotificationData?.mainFieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: queryNotificationData?.mainFieldLabel,
                                  }}
                                />
                              ) : (
                                queryNotificationData?.mainFieldLabel
                              )} ({queryNotificationData?.mainFieldName})
                            </div>
                          </Col>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Sub Field Label (Name)</small>
                            <div style={{ fontSize: "13px" }}>
                              {isHTMLIdentifier(queryNotificationData?.fieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: queryNotificationData?.fieldLabel,
                                  }}
                                />
                              ) : (
                                queryNotificationData?.fieldLabel
                              )} ({queryNotificationData?.fieldName})
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Sub Field Value</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryNotificationData?.fieldValue?.startsWith("https://") ? (
                                <Badge
                                  onClick={() =>
                                    window.open(queryNotificationData.fieldValue, "_blank", "noopener,noreferrer")
                                  }
                                  bg="primary-subtle" className="CP text-primary" style={{ borderRadius: 3, fontSize: 10 }}>
                                  View File
                                </Badge>
                              ) : (
                                queryNotificationData?.fieldValue
                              )}
                            </div>
                          </Col>
                          <Col xs={6}>
                            <small className="text-muted fw-bold">Status</small>
                            <div>
                              <Badge bg={queryNotificationData?.status === "open" ? "danger-subtle" : queryNotificationData?.status === "cancel" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${queryNotificationData?.status === "open" ? "text-danger" : queryNotificationData?.status === "cancel" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{queryNotificationData?.status}</Badge>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-2 border bg-light">
                      <Card.Body className="p-3">
                        <Row>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Raised by</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryNotificationData?.generatedByName}
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Assigned to</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryNotificationData?.assignedToName}
                            </div>
                          </Col>
                          <Col xs={4}>
                            <small className="text-muted fw-bold">Due Age</small>
                            <div style={{ fontSize: "13px" }}>
                              {queryNotificationData?.dueAge}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <div className="hstack justify-content-end">
                      {((StudyMode === "DBP Mode" || !StudyMode?.startsWith("SDV")) && queryNotificationData?.status === "open") &&
                        <div className="hstack gap-2">
                          <Badge onClick={() => { if (!queryNotificationStatusButtonLoader) generateQueryNotificationStatusStudySubjectFormField(queryNotificationData?.queryId, "close") }} bg={queryNotificationStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                            {queryNotificationStatusButtonLoader ? <div className="hstack gap-2">
                              <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                            </div>
                              : "Close Notification"
                            }
                          </Badge>
                        </div>
                      }
                    </div>
                    <div>
                      <h6 style={{ fontSize: 14 }} className="fw-bold mb-3">Notification History & Audit</h6>
                      {dataEntryQueryNotificationDiscussionLoader ?
                        <div
                          className="hstack justify-content-center"
                          style={{ height: "calc(100vh - 580px)" }}
                        >
                          <PageLoader />
                        </div> :
                        dataEntryQueryNotificationDiscussion.map((item, index) => (
                          <div key={index} className="mb-3">
                            <div className="d-flex align-items-start gap-3">
                              <div className="d-flex flex-column align-items-center">
                                <div style={{
                                  width: "12px", height: "12px", borderRadius: "50%",
                                  background: (item.status === "answered" || item.status === "responded") ? "#0d6efd" :
                                    item.status === "close" ? "#198754" :
                                      item.status === "cancel" ? "#d19916" :
                                        (item.status === "open" || item.status === "re-open") ? "#ed0000" :
                                          "#787878",
                                  marginTop: "4px"
                                }}>
                                </div>
                                {index < dataEntryQueryNotificationDiscussion?.length - 1 && (
                                  <div style={{ width: "2px", height: "40px", background: "#dee2e6", margin: "4px 0" }}></div>
                                )}
                              </div>
                              <div style={{ flex: 1 }}>
                                <div className="hstack gap-2 flex-wrap">
                                  <span className="fw-bold text-capitalize">{item.actionStatus === "cancel" ? "cancelled" : item.actionStatus === "close" ? "closed" : item?.actionStatus}</span>
                                  <Badge bg={`${getStatusBadge(item.status)}-subtle`} className={`text-${getStatusBadge(item.status)} rounded-1 text-capitalize`} style={{ fontSize: 9 }}>
                                    {item.status === "cancel" ? "cancelled" : item.status === "close" ? "closed" : item?.status}
                                  </Badge>
                                  <small className="text-muted ms-auto">{item.commentedByName}, {item.commentedDT}</small>
                                </div>
                                <Card className="mt-2 border bg-light p-2 w-100">
                                  <div className="mt-1" style={{ fontSize: "13px", color: "#212529" }}>
                                    {item.comment}
                                  </div>
                                </Card>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                }
              </div>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FieldErrorNotification;